import React, { useEffect } from 'react';

type CalendlyWidgetProps = {
  url?: string;
  minWidth?: string;
  height?: string;
};

const CalendlyWidget: React.FC<CalendlyWidgetProps> = ({
  url = 'https://calendly.com/tumsa-letif/30min?hide_event_type_details=1&hide_gdpr_banner=1',
  minWidth = '320px',
  height = '700px',
}) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const existingScript = document.querySelector('script[data-calendly-widget]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.setAttribute('data-calendly-widget', 'true');
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="calendly-widget-container">
      <div className="calendly-inline-widget" data-url={url} style={{ minWidth, height }} />
    </div>
  );
};

export default CalendlyWidget;
